class EnvHelper {
    #ENV_KEY = 'REACT_APP_';
    #ENV = import.meta.env;
  
    get = (key) => {
      return this.#ENV[this.#ENV_KEY + key] ?? '';
    };
  
  }
  
  export default new EnvHelper();